module.exports = __webpack_public_path__ + "static/media/icon_202.7151aa6a.svg";